import {
  Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter,
  HostListener
} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';

declare var $:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-view',
    templateUrl: 'view.component.html',
    styleUrls: ['view.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.SubscriptionService, Communication.AccesscodeService,],
    standalone: false
})
export class ViewComponent implements OnInit, OnDestroy {

  modalInfoVisibility:boolean=false;

  accessCode:string="";
  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];
  theJob:Communication.Job;

  page: number = 1;
  rotation: number = 0;
  zoom: number = 1.0;
  originalSize: boolean = true;
  showAll: boolean = true;
  pdf: any;
  renderText: boolean = false;

  pdfSrc: any = {
    'url': '',
    'httpHeaders': {
      'access_token':"1"
    }
  };
  containers: Array<Container> = [];
  widgets: Array<Communication.Recipient> = [];
  stopResizeEvent:boolean=false;


  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private usersApi:Communication.UsersService,
              private subscriptionsApi:Communication.SubscriptionService,
              private accescodeApi:Communication.AccesscodeService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              private notificationService: NotificationService,
              public translate: TranslateService,
              private http: HttpClient
  )
  {






    this.afterLoadComplete = this.afterLoadComplete.bind(this);
  }

  ngOnInit() {

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        (param) => {
          //convert string to number with +
          this.accessCode = param['code'];
          console.log("accessCode:" + this.accessCode);

        })
      );

      this.onResize("");
      this.getTheJobWithAccessCode();

  }


  @HostListener('window:resize', ['$event'])
  onResize($event:any) {
    if(this.stopResizeEvent) {
      return;
    }

    this.stopResizeEvent = true;

    let width:number = $event != "" ? $event.target.innerWidth : $(window).width();
    //console.log("::: " + width);

    if(width > 800) this.zoom = 1;
    if(width < 700) this.zoom = 0.9;
    if(width < 650) this.zoom = 0.85;
    if(width < 600) this.zoom = 0.8;
    if(width < 550) this.zoom = 0.75;
    if(width < 500) this.zoom = 0.7;
    if(width < 450) this.zoom = 0.65;
    if(width < 400) this.zoom = 0.6;
  }

  getTheJobWithAccessCode() {
    this.subscriptions.push(this.accescodeApi.accesscodesCodeJobGet(this.accessCode).subscribe(
      (response:Communication.JobOfAccessCode) => {
        this.theJob = response.job;
        console.log(this.theJob)
        let fileURL = Config.WEBSERVICEURL + '/accesscodes/' + this.accessCode + '/download';
        this.loadFile(fileURL);

        let toolbarEvent = new ToolbarEvent(
          ToolbarEventPageEnum.VIEW,
          this.theJob.type,
          this.theJob.user.id,
          "",
          this.theJob.name,
          this.theJob.status,
          "",
          Config.WEB_APP_URL + "/view/" + this.accessCode,
          String(response.permission));

        // The Signing Log affordance is rendered from what the API says, never
        // decided here. /view/{code} serves both completion codes and validation codes, and
        // only the server knows which this is (accesscode.is_validation) — the endpoint
        // refuses validation codes, so the flag and the endpoint agree by construction.
        // Read defensively: the field arrives with the agree.yaml change and is absent until
        // then, which correctly renders nothing.
        toolbarEvent.signingLogAvailable = (response as any)?.signingLogAvailable === true;
        this.toolbarService.action(toolbarEvent);

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err)
      }
    ));
  }

  loadFile(fileURL: string) {
    // Use the accesscode API to download PDF as blob and create blob URL
    this.accescodeApi.accesscodesCodeDownloadGet(this.accessCode).subscribe(
      (data: Blob) => {
        if (data.type !== 'application/json') {
          // Success - create blob URL for PDF viewer
          const blobUrl = URL.createObjectURL(data);
          this.pdfSrc.url = blobUrl;
          console.log('PDF loaded successfully as blob URL');
        } else {
          // Error response came as JSON
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              console.log('PDF load error:', errorJson);
              this.notificationService.displayError(errorJson.description || errorJson.message);
            } catch (e) {
              this.notificationService.documentNotFound();
            }
          };
          reader.readAsText(data);
        }
      },
      (err: any) => {
        console.log('Error loading PDF:', err);
        this.notificationService.documentNotFound();
      }
    );
  }

  afterLoadComplete(pdf: any) {
    this.pdf = pdf;
  }

  onError($event:any){
    //console.log("onError ");
    //this.notificationService.documentNotFound();
  }


  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "ROTATE":
        this.rotate(Number(event.value));
        break;
      case "INCREMENT_ZOOM":
        this.incrementZoom(Number(event.value));
        break;
      case "JOB_DETAILS_INFO": {
        this.modalInfoVisibility = true;
        this.showRecipientOrderList();
        break;
      }
      case "DOWNLOAD_DOC_WITH_LIK": {
        this.modalInfoVisibility = true;
        this.DownloadDocumentWithLink(this.accessCode, this.theJob.name + ".pdf", "");
        break;
      }
      case "DOWNLOAD_SIGNING_LOG": {
        this.DownloadSigningLog();
        break;
      }
    }
  }

  incrementPage(amount:number) {
    this.page += amount;
  }

  incrementZoom(amount:number) {
    let newZoom = this.zoom + amount >= 0.2 ? this.zoom + amount : 0.2;

    if(this.zoom != newZoom) {
      this.zoom = newZoom;
    }
  }

  rotate(angle:number) {
    this.rotation += angle;
  }

  showRecipientOrderList(){

    this.containers = [];
    let maxOrderNo = 1;

    for (let recipient of this.theJob.recipients) {
      if(Number(recipient.orderno) > maxOrderNo) {
        maxOrderNo = Number(recipient.orderno);
      }
    }

    for (let i=1; i<=maxOrderNo; i++) {
      let orderGroup:Array<Communication.Recipient> = [];

      for (let recipient of this.theJob.recipients) {
        if(Number(recipient.orderno) == i)
          orderGroup.push(recipient);
      }

      //if(orderGroup.length > 0) {
      //console.log("orderGroup: "+ i +". - lenght: "+ orderGroup.length)
      this.containers.push(new Container(orderGroup));
      //}
    }
  }

  /**
   *
   * Custom http for Download given document
   * @param accessToken System access token
   * @param id id of the document
   */
  /*
  private documentsAccessCodeDownloadGet(code:string, pass?: string, extraHttpRequestParams?:any):Observable<any> {
    const path = this.documentsApi.basePath + '/accesscodes/{code}/download'
        .replace('{' + 'code' + '}', String(code));

    let queryParameters = new URLSearchParams();
    let headerParams = this.documentsApi.defaultHeaders;
    // verify required parameter 'code' is not null or undefined
    if (code === null || code === undefined) {
      throw new Error('Required parameter accessToken was null or undefined when calling documentsIdDownloadGet.');
    }
    // verify required parameter 'pass' is not null or undefined
    if (pass === null || pass === undefined) {
      throw new Error('Required parameter pass was null or undefined when calling documentsIdDownloadGet.');
    }
    if (pass !== undefined) {
      queryParameters.set('original', String(pass));
    }

    let requestOptions:RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters,
      responseType: ResponseContentType.ArrayBuffer
    };

    return this.documentsApi.getHttp().request(path, requestOptions)
      .map((response:Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response;
        }
      });
  }
*/

  /**
   * Download the Signing Log for the job this access code belongs to.
   *
   * Authorisation is entirely server-side: GET /accesscodes/{code}/signinglog inherits the
   * COMPLETED check and the 15-day expiry, and refuses a validation code outright. The button
   * is only rendered when the API said so, so this is the second of two agreeing checks rather
   * than the only one.
   */
  public DownloadSigningLog() {
    const name = (this.theJob?.name || 'document') + ' - Signing Log.pdf';
    this.notificationService.documentDownloadStarted(name);

    const url = Config.WEBSERVICEURL + '/accesscodes/' + encodeURIComponent(this.accessCode) + '/signinglog';

    this.subscriptions.push(this.http.get(url, { responseType: 'blob' }).subscribe(
      (data: Blob) => {
        if (data.type === 'application/json') {
          // The API reports refusals as a JSON body with a 200, the same shape the document
          // download already handles — an expired window or a validation code lands here.
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              this.notificationService.displayError(errorJson.description || errorJson.message);
            } catch (e) {
              this.notificationService.documentNotFound();
            }
          };
          reader.readAsText(data);
          return;
        }

        const blobUrl = window.URL.createObjectURL(data);
        const linkElement = document.createElement('a');
        linkElement.setAttribute('href', blobUrl);
        linkElement.setAttribute('download', name);
        linkElement.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: false }));
        window.URL.revokeObjectURL(blobUrl);
      },
      (err) => {
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  public DownloadDocumentWithLink(accessCode:string, name:string, password: string) {
    this.notificationService.documentDownloadStarted(name);

    this.subscriptions.push(this.accescodeApi.accesscodesCodeDownloadGet(accessCode, password).subscribe(
      (data: Blob) => {
        // Check if the response is JSON (error) or binary (success)
        if (data.type === 'application/json') {
          // Error response - parse JSON from blob
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              console.log('Download error:', errorJson);
              this.notificationService.displayError(errorJson.description || errorJson.message);
            } catch (e) {
              this.notificationService.documentNotFound();
            }
          };
          reader.readAsText(data);
        } else {
          // Success - download the file
          let url = window.URL.createObjectURL(data);
          let linkElement = document.createElement('a');

          linkElement.setAttribute('href', url);
          linkElement.setAttribute("download", name);

          let clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
          });
          linkElement.dispatchEvent(clickEvent);

          // Clean up
          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        }
      },
      (err:any) => {
        // Log errors if any
        console.log(err);
        if (err.error instanceof Blob) {
          // Error response came as blob, parse it
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result as string);
              this.notificationService.displayError(errorJson.description || errorJson.message);
            } catch (e) {
              this.notificationService.documentNotFound();
            }
          };
          reader.readAsText(err.error);
        } else {
          this.notificationService.documentNotFound();
        }
      }
    ));
  }

  ngOnDestroy() {
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }
}


class Container {
  constructor(public widgets: Array<Communication.Recipient>) {}
}
